import React, { useEffect, useState } from "react";

const NotFound = () => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    const fetch404Page = async () => {
      try {
        const response = await fetch("/404.html");
        const html = await response.text();
        setHtmlContent(html);
      } catch (error) {
 
      }
    };

    fetch404Page();
  }, []);

  return (
    <>
      {/* Render the fetched HTML content */}
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </>
  );
};

export default NotFound;
